import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartPie"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM19.5 11.25H12.75V4.53749C16.3136 4.87735 19.1403 7.68832 19.5 11.25ZM11.5649 19.5C7.62349 19.3167 4.4981 16.1108 4.41505 12.1659C4.332 8.22111 7.3197 4.88652 11.2499 4.53749V11.2875C11.2499 12.1159 11.9215 12.7875 12.7499 12.7875H19.4999C19.0853 16.7921 15.5829 19.7549 11.5649 19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartPie.vue"]]);
